import { checkObjWithNameProp } from 'CorePackage/MainModule/common/checkObjWithNameProp';

import { RenderFunc } from '../types/RenderFunc';

interface IObjWithName {
  name: string;
}

export const renderIsActWasRead: RenderFunc = item => {
  const { newValue, oldValue } = item;
  const checkedOldValue = checkObjWithNameProp<IObjWithName>(oldValue, 'name')
    ? oldValue.name
    : (typeof oldValue === 'string' && oldValue) || '';
  const checkedNewValue = checkObjWithNameProp<IObjWithName>(newValue, 'name')
    ? newValue.name
    : (typeof newValue === 'string' && newValue) || '';

  return {
    renderedOldValue: checkedOldValue,
    renderedNewValue: checkedNewValue,
  };
};
